import { VariantUI } from 'components/commercetools-ui/organisms/product/product-details/types';
import { isVariantOnStock } from 'helpers/utils/variantEligibility';
import { getAttributeLabel } from 'helpers/utils/attributes';
import { Variant } from 'types/entity/product';

const normalizeValue = (val: any) => {
  const label = getAttributeLabel(val);
  return label === undefined ? '' : label.toString().toLowerCase().trim();
};

export const discardRepeatedValues = (
  variants: Variant[],
  currentVariant: Record<string, any>,
  attribute: string,
  level: string,
  attributesToDisplay: Record<string, any>,
):VariantUI[] => {
  const seen = new Set();

 
 const distinctVariant: Variant[] = [];

  variants.forEach((variant) => {
    const value = normalizeValue(variant.attributes?.[attribute]);

    if (!value || seen.has(value)) {
      return;
    }

    seen.add(value);

    let matchingVariant: Variant | undefined;

    if (level === 'primaryAttribute') {
      matchingVariant = variants.find(
        (v) =>
          normalizeValue(v.attributes?.[attribute]) === value &&
          (!attributesToDisplay.secondaryAttribute ||
            normalizeValue(
              v.attributes?.[attributesToDisplay.secondaryAttribute],
            ) === normalizeValue(currentVariant.secondaryAttribute)) &&
          (!attributesToDisplay.tertiaryAttribute ||
            normalizeValue(
              v.attributes?.[attributesToDisplay.tertiaryAttribute],
            ) === normalizeValue(currentVariant.tertiaryAttribute)),
      );
    } else if (level === 'secondaryAttribute') {
      matchingVariant = variants.find(
        (v) =>
          normalizeValue(v.attributes?.[attribute]) === value &&
          normalizeValue(
            v.attributes?.[attributesToDisplay.primaryAttribute],
          ) === normalizeValue(currentVariant.primaryAttribute) &&
          (!attributesToDisplay.tertiaryAttribute ||
            normalizeValue(
              v.attributes?.[attributesToDisplay.tertiaryAttribute],
            ) === normalizeValue(currentVariant.tertiaryAttribute)),
      );
    } else if (level === 'tertiaryAttribute') {
      matchingVariant = variants.find(
        (v) =>
          normalizeValue(v.attributes?.[attribute]) === value &&
          normalizeValue(
            v.attributes?.[attributesToDisplay.primaryAttribute],
          ) === normalizeValue(currentVariant.primaryAttribute) &&
          normalizeValue(
            v.attributes?.[attributesToDisplay.secondaryAttribute],
          ) === normalizeValue(currentVariant.secondaryAttribute),
      );
    }

    distinctVariant.push(matchingVariant ?? variant);
  });

  return distinctVariant.map((variant) => {
    const attrs = variant?.attributes?.[attribute];
    let disabled = false;

    if (level === 'primaryAttribute' && attrs) {
      disabled = !variants.some(
        (v) =>
          normalizeValue(v.attributes?.[attributesToDisplay.primaryAttribute]) === normalizeValue(attrs) &&
          (!attributesToDisplay.secondaryAttribute ||
            normalizeValue(v.attributes?.[attributesToDisplay.secondaryAttribute]) === normalizeValue(currentVariant.secondaryAttribute)) &&
          (!attributesToDisplay.tertiaryAttribute ||
            normalizeValue(v.attributes?.[attributesToDisplay.tertiaryAttribute]) === normalizeValue(currentVariant.tertiaryAttribute))
      );
    } else if (level === 'secondaryAttribute' && attrs) {
      disabled = !variants.some(
        (v) =>
          normalizeValue(v.attributes?.[attributesToDisplay.secondaryAttribute]) === normalizeValue(attrs) &&
          normalizeValue(v.attributes?.[attributesToDisplay.primaryAttribute]) === normalizeValue(currentVariant.primaryAttribute) &&
          (!attributesToDisplay.tertiaryAttribute ||
            normalizeValue(v.attributes?.[attributesToDisplay.tertiaryAttribute]) === normalizeValue(currentVariant.tertiaryAttribute))
      );
    } else if (level === 'tertiaryAttribute' && attributesToDisplay.tertiaryAttribute) {
      disabled = !variants.some(
        (v) =>
          normalizeValue(v.attributes?.[attributesToDisplay.tertiaryAttribute]) === normalizeValue(attrs) &&
          normalizeValue(v.attributes?.[attributesToDisplay.primaryAttribute]) === normalizeValue(currentVariant.primaryAttribute) &&
          normalizeValue(v.attributes?.[attributesToDisplay.secondaryAttribute]) === normalizeValue(currentVariant.secondaryAttribute)
      );
    }
    const outOfStock = !isVariantOnStock(variant);

    return {
      ...variant,
      outOfStock,
      disabled,
      level
    };
  });
};
